import moment from 'moment';

export const validateDate = date => {
  // Matches the format YYYY-MM-DD
  const dateRegex = /^\d{4}([./-])\d{2}\1\d{2}/;

  return dateRegex.test(date) && moment(date).isValid();
};

export const validateEmail = email => {
    const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    return emailRegex.test(email);
};



// WEBPACK FOOTER //
// ./src/features/shared/validators.js